import { Flex } from 'antd';
import styled from 'styled-components';
import { ImageContainer as CommonImageContainer } from '../../styles/commonStyles';

export const Section = styled.section`
  padding: 24px;
  background: #fff;
`;

export const ImageContainer = styled(CommonImageContainer)`
  width: 100%;
  height: 200px;
`;

export const DeleteButton = styled.div`
  padding: 12px;
  cursor: pointer;
  font-size: 18px;
  color: #999;
  :hover {
    color: ${(props) => props.theme.antd?.colorPrimary};
  }
`;
